import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router';
import { PLANIFICATION_STATUS, PROFIL, REQUEST_PASS_STATUS, REQUEST_PASS_TYPE } from '../../constants/enum';
import { URL_API } from '../../utils/globalConfig';
import useAuthz from '../../hooks/useAuthz';
import { logError } from '../Utils/FormatData';
import ModalViewContract from '../../views/Dossier/ModalViewContract';
import AvailablePeriodModal from '../Calendar/AvailablePeriodModal';
import UnavailablePeriodModal from '../Calendar/UnavailablePeriodModal';
import MyDialog from '../Layout/MyDialog';
import { dateFormatter } from '../../utils/dateHelper';

const css = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '90%',
        width: '40%',
        backgroundColor: 'white',
        borderRadius: '5px',
        minHeight: '60%',
    },
    modalUnavailablePeriod: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 'auto',
        width: '75%',
        backgroundColor: 'white',
        borderRadius: '5px',
    },
    modalAvailablePeriod: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '95%',
        width: '85%',
        backgroundColor: 'white',
        borderRadius: '5px',
    },
    containerUnavailablePeriod: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    containerAvailablePeriod: {
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        overflowY: 'auto',
    },
    devisContainer: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '90%' },
    fullRow: { height: '100%', width: '100%', alignItems: 'center' },
    row: { height: 'calc(100% - 110px)', flexDirection: 'column', justifyContent: 'normal' },
    rowSelectedFolder: {
        overflow: 'visible',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        margin: '20px',
    },
    rowValidation: { display: 'flex', justifyContent: 'right', width: '100%' },
    formControl: { width: '100%', margin: '0' },
    tableHead: { border: '1px solid #4db4da', backgroundColor: '#0094ca' },
    gridFieldSet: {
        borderColor: 'rgba(0, 0, 0, 0.23)',
        height: '100%',
        overflowY: 'auto',
        margin: '0',
        padding: '15px',
        maxHeight: '400px',
        minHeight: '400px',
    },
    gridLegend: {
        color: 'rgba(0, 0, 0, 0.6)',
        fontFamily: 'Gadugi, sans-serif',
        fontWeight: '400',
        padding: '0',
        transform: 'scale(0.75)',
        lineHeight: '0',
    },
    gridRadioGroup: { display: 'flex', flexDirection: 'row', marginLeft: '20px' },
    gridItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },
};
const demandePassageStyle = {
    textField: { width: '50%', margin: '20px' },
    textFieldShort: { width: '25%', margin: '20px' },
    textFieldFixed: { maxWidth: '200px', margin: '20px' },
    rowIntoPaper: { maxHeight: '100px', alignItems: 'center' },
    sectionPaper: { width: 'calc(100% - 20px)', padding: '0 0 40px 20px', margin: '15px' },
    sectionLibelle: { padding: '15px', textTransform: 'uppercase', fontFamily: 'Gadugi' },
    listItem: { marginBottom: '10px', fontSize: '16px' },
};

const statusList = [
    { label: 'Nouveau', value: PLANIFICATION_STATUS.NEW },
    { label: 'Accepté prévisionnel', value: PLANIFICATION_STATUS.ACCEPTED_PROVISIONAL },
    { label: 'Accepté centre', value: PLANIFICATION_STATUS.ACCEPTED_CENTER },
    { label: 'Confirmé client', value: PLANIFICATION_STATUS.CONFIRMED_CLIENT },
    { label: 'Confirmé centres', value: PLANIFICATION_STATUS.CONFIRMED_CENTERS },
    { label: 'Accord émis', value: PLANIFICATION_STATUS.AGREEMENT_ISSUED },
    { label: 'Passage effectué', value: PLANIFICATION_STATUS.PASSAGE_MADE },
    { label: 'Non effectué', value: PLANIFICATION_STATUS.NOT_DONE },
    { label: 'Annulé', value: PLANIFICATION_STATUS.CANCELLED },
    { label: 'Refusé', value: PLANIFICATION_STATUS.REFUSED },
];

const centerStatusList = [
    { label: 'En attente', value: 'AWAITING_VALIDATION' },
    { label: 'Accepté', value: 'VALIDATED' },
    { label: 'Refusé', value: 'REFUSED' },
];

const EditPlanificationModal = (props) => {
    const {
        openModal,
        setOpenModal,
        planification,
        setPlanification,
        mode,
        centers,
        setReloadDatas,
        client,
        requestPassId,
        goToDate,
    } = props;
    const alert = useAlert();
    const navigate = useNavigate();
    const [authz, user, profil] = useAuthz();
    const [loading, setLoading] = useState(false);
    const [listCenters, setListCenters] = useState([]);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);

    const [unavailablePeriod, setUnavailablePeriod] = useState({ centers: [], start: null, end: null, comment: null });
    const [concernedRequestPass, setConcernedRequestPass] = useState(null);
    const [availablePeriod, setAvailablePeriod] = useState({
        id: 0,
        client: null,
        requestPass: null,
        centersList: [],
        centers: [],
        start: null,
        end: null,
        status: PLANIFICATION_STATUS.NEW,
        askType: 'wanted',
        convoyInfos: {
            contact: [{
                name: '',
                phone: '',
            }],
            immatriculations: [{
                immatriculation: '',
            }],
            confirmed: null,
        },
        concernedPath: {
            full: true,
            aller: [],
            retour: [],
            selectedPath: 'aller',
            fromReport: false,
        },
        additionalInfos: {
            client: null,
            services: null,
        },
        step: 1,
        maxPlanification: {
            nbAller: 0,
            nbRetour: 0,
        },
    });
    const [listeRaisonsSociales, setListeRaisonsSociales] = useState([]);
    const [listAvailableRequestPass, setListAvailableRequestPass] = useState([]);
    const [openContractModal, setOpenContractModal] = useState(false);
    const [openModalIndisponibility, setOpenModalIndisponibility] = useState(false);
    const [modalIndisponibilityMessage, setModalIndisponibilityMessage] = useState('');
    const [createdFromRequestPass, setCreatedFromRequestPass] = useState(false);
    const [contractId, setContractId] = useState(null);
    const [oldStatus, setOldStatus] = useState('');
    const [isInitialised, setIsInitialised] = useState(false);

    const stepsPermissions = {
        0: [PROFIL.GESTIONNAIRE, PROFIL.CLIENT],
        1: [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE, PROFIL.CLIENT],
        2: [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE, PROFIL.CLIENT],
        3: [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE],
        4: [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE],
        5: [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE, PROFIL.CLIENT],
        6: [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE],
        7: [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE, PROFIL.INTERVENANT],
        8: [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE],
    };

    //#region useEffect

    useEffect(() => {
        document.title = 'TE - Planification';

        if (profil.profil === 6) {
            alert.error(`Vous n'êtes pas autorisé à accéder au module de planification`);
            navigate('/');
        } else {
            apiGetListSocialReason();
        }
    }, []);
    useEffect(() => {
        if (centers) setListCenters(centers.map((aCenter) => {
            return { 'id': aCenter.id, 'label': aCenter.label };
        }));
    }, [centers]);
    useEffect(() => {
        if (openModal) {
            setCreatedFromRequestPass(false);
            if (mode === PLANIFICATION_STATUS.UNAVAILABLE) {
                if (planification) {
                    setUnavailablePeriod({
                        centers: planification.metadata.centers?.map((aCenter) => {
                            return aCenter.id;
                        }),
                        start: moment(planification.metadata.startDate),
                        end: moment(planification.metadata.endDate),
                        comment: planification.metadata.comment,
                    });
                }
            }
            if (mode === PLANIFICATION_STATUS.AVAILABLE) {

                if (requestPassId && client) {
                    // TODO: si on créé depuis le dossier, on doit griser les select des clients + dossiers
                    setCreatedFromRequestPass(true);
                    setAvailablePeriod({
                        ...availablePeriod,
                        status: PLANIFICATION_STATUS.NEW,
                        client: client,
                        requestPass: requestPassId,
                    });
                }

                if (planification) {
                    setIsDeleted(planification.metadata.status === PLANIFICATION_STATUS.REFUSED || planification.metadata.status === PLANIFICATION_STATUS.CANCELLED);
                    setOldStatus(planification.metadata.status);
                    setAvailablePeriod({
                        id: planification?.id || 0,
                        additionalInfos: planification.metadata.additionalInfos,
                        askType: planification.metadata.askType,
                        centers: planification.metadata.centers,
                        client: planification.metadata.client,
                        concernedPath: planification.metadata.concernedPath,
                        convoyInfos: planification.metadata.convoyInfos,
                        end: moment(planification.metadata.endDate),
                        start: moment(planification.metadata.startDate),
                        status: planification.metadata.status,
                        step: planification.metadata.step,
                        requestPass: planification.dossier_id,
                    });
                }
            }
        }
    }, [openModal]);
    useEffect(async () => {
        if (availablePeriod.client) {
            await apiGetListRequestPassByClient();
        }
    }, [availablePeriod.client]);

    useEffect(() => {
        if (availablePeriod.concernedPath.full && isInitialised) {
            handleTronconChange(null, 0, availablePeriod.concernedPath.selectedPath);
        }
    }, [availablePeriod.concernedPath.full, availablePeriod.concernedPath.selectedPath]);

    useEffect(() => {
        updateMaxPlanifications();
    }, [availablePeriod.concernedPath.selectedPath]);

    useEffect(() => {
        updateMaxPlanifications();
    }, [availablePeriod.askType]);

    useEffect(() => {
        if (openModalIndisponibility) {
            apiGetUnavailablePeriod();
        }
    }, [openModalIndisponibility]);

    useEffect(() => {
        if (concernedRequestPass) {

            updateMaxPlanifications();

            setAvailablePeriod(prevAvailablePeriod => ({
                ...prevAvailablePeriod,
                aller: concernedRequestPass.metadata.trajetDescr.descr,
                retour: concernedRequestPass.metadata.trajetDescr.descrRetour,
                trajetType: concernedRequestPass.metadata.trajetDescr.type,
                centersList: concernedRequestPass.metadata.complInfo.refCtr,
                hasReturn: concernedRequestPass.metadata.trajetDescr.descrRetour.length > 1 || concernedRequestPass.metadata.trajetDescr.descrRetour[0].numeroSection !== null,
            }));

            if (availablePeriod.id === 0) {
                setAvailablePeriod(prevAvailablePeriod => ({
                    ...prevAvailablePeriod,
                    status: PLANIFICATION_STATUS.NEW,
                    centers: concernedRequestPass.metadata.complInfo.refCtr.map((aCenter) => {
                        return {
                            id: aCenter.id,
                            name: aCenter.name,
                        };
                    }),
                    concernedPath: {
                        full: true,
                        aller: concernedRequestPass.metadata.trajetDescr.descr,
                        retour: [],
                        selectedPath: 'aller',
                        fromReport: false,
                    },
                }));
            } else {
                let currentPlanifIndex = 0;
                let concernedPath = availablePeriod.concernedPath.selectedPath;

                if (concernedRequestPass && planification) {
                    currentPlanifIndex = concernedRequestPass.planifications.filter((aPlanification) => aPlanification.deleted === false && aPlanification.metadata.concernedPath.selectedPath === concernedPath).findIndex((aPlanification) => aPlanification.id === planification.id);
                }

                let planifications = concernedRequestPass.planifications.sort((a, b) => a.id - b.id).filter((aPlanification) => aPlanification.deleted === false && aPlanification.metadata.concernedPath.selectedPath === concernedPath);
                let centers = [];
                concernedRequestPass.metadata.complInfo.refCtr.forEach((aCenter) => {
                    if (!planifications[currentPlanifIndex].metadata.centers.some((aPlanifCenter) => Number(aPlanifCenter.id) === Number(aCenter.id))) {
                        centers.push(aCenter);
                    } else {
                        centers.push(planifications[currentPlanifIndex].metadata.centers.find((aPlanifCenter) => Number(aPlanifCenter.id) === Number(aCenter.id)));
                    }
                });

                setAvailablePeriod(prevAvailablePeriod => ({
                    ...prevAvailablePeriod,
                    date_creation: concernedRequestPass.planifications[currentPlanifIndex].date_creation,
                    centers: centers
                }));

                setIsInitialised(true);
            }
        }

    }, [concernedRequestPass]);

    useEffect(async () => {
        if (availablePeriod.requestPass) {
            apiGetContract();
            await apiGetRequestPass();
        }
    }, [availablePeriod.requestPass]);

    // Synchronisation des centres avec ceux fournit dans le dossier
    // Lié au cas suivant :
    // 1. Si on créé un dossier sans centre pour les trajets.
    // 2. On crée une planification.
    // 3. On affecte un centre sur le trajet dans le dossier.
    // 4. Lorsqu'on édite la planification, le centre au trajet concerné n'était pas repris.
    useEffect(() => {
       if (isInitialised) {
           let aPeriod = { ...availablePeriod };
           let concernedPath = { ...aPeriod.concernedPath };
           const selectedPath = aPeriod[concernedPath.selectedPath] ?? [];

           if (String(concernedPath.full) === "true") {
               concernedPath[concernedPath.selectedPath] = selectedPath.map(s => ({ ...s }));
           } else {
               const selectedConcernedPath = concernedPath[concernedPath.selectedPath] ?? [];
               concernedPath[concernedPath.selectedPath] = selectedConcernedPath.map((aConcernedPath) => ({
                   ...aConcernedPath,
                   centres: selectedPath.find((aPath) => aPath.numeroSection === aConcernedPath.numeroSection)?.centres || [],
               }));
           }

           setAvailablePeriod({ ...aPeriod, concernedPath });
       }
    }, [isInitialised])

    //#endregion

    //#region API

    const apiGetContract = () => {
        if (availablePeriod.requestPass) {
            axios({
                method: 'get',
                url: URL_API + '/demande-passage/verifier-accords-passage',
                params: { planificationId: availablePeriod.id },
            })
            .then((response) => {
                setContractId(response.data);
            })
            .catch((error) => {
                logError(alert, error);
            });
        }
    };

    const apiGetListSocialReason = () => {
        axios(profil.profil === 1 || profil.profil === 2 ? {
            method: 'GET',
            url: `${URL_API}/utilisateur/liste-client`,
        } : { method: 'GET', url: `${URL_API}/utilisateur/liste-client`, params: { userId: user.user_id } })
        .then((response) => {
            let clients = [];

            response.data.forEach((e) => {
                clients.push(e.raison_sociale);
            });

            setListeRaisonsSociales(clients);
        })
        .catch((error) => {
            logError(alert, error);
        });
    };
    const apiGetListRequestPassByClient = () => {
        axios({
            method: 'post',
            url: URL_API + '/demande-passage/liste-by-user',
            data: {
                raison_sociale: availablePeriod.client,
                type: null,
                hubs: null,
                region: null,
            },
        })
        .then(async (response) => {
            let listValidatedRequestPass = response.data.filter((e) => (e.id_status !== REQUEST_PASS_STATUS.BLOCKED && e.id_status !== REQUEST_PASS_STATUS.REFUSED && e.id_status !== REQUEST_PASS_STATUS.TERMINATED && e.id_status !== REQUEST_PASS_STATUS.CANCELLED));
            let notTypeSuperieur = listValidatedRequestPass.filter((e) => e.metadata.reference.typeDemande !== REQUEST_PASS_TYPE.SUPERIEUR);
            let listValidatedRequestPassId = notTypeSuperieur.map((aValidatedRequestPass) => {
                return aValidatedRequestPass.id.toString();
            });
            setListAvailableRequestPass(listValidatedRequestPassId);

            if (availablePeriod.requestPass) {
                await apiGetRequestPass();
            }
        })
        .catch((error) => {
            logError(alert, error);
        });
    };
    const apiGetRequestPass = () => {
        axios({
            method: 'GET',
            url: `${URL_API}/demande-passage/recuperer-demande`,
            params: { 'id': availablePeriod.requestPass },
        })
        .then((response) => {
            if (response.data) {
                response.data.planifications = response.data.planifications?.sort((a, b) => a.id - b.id).filter((aPlanification) => aPlanification.deleted === false);
                setConcernedRequestPass(response.data);
            }
        })
        .catch((error) => {
            logError(alert, error);
        });
    };
    const apiSavePeriod = (period) => {
        axios({
            method: 'post',
            url: `${URL_API}/planification/save`,
            data: period,
            params: { userAction: user.user_id },
        })
        .then(() => {
            setLoading(false);
            setReloadDatas(true);
            alert.success('La période a été enregistrée avec succès');
            handleCloseModal();
        })
        .catch((error) => {
            setLoading(false);
            logError(alert, error);
        });
    };

    const apiGetUnavailablePeriod = () => {
        axios({
            method: 'post',
            url: URL_API + '/planification/get-unavailable-period',
            data: {
                centers: availablePeriod.centers.map((aCenter) => aCenter.id),
                startDate: moment(availablePeriod.start).format().split('+')[0],
                endDate: moment(availablePeriod.end).format().split('+')[0],
            },
        })
        .then((response) => {
            setModalIndisponibilityMessage('');
            if (response.data.length > 0) {
                let msg = '';
                response.data.map((aPeriod) => {
                    let centers = '';
                    aPeriod.metadata.centers.map((aCenter) => {
                        let center = availablePeriod.centersList.find((aCenterList) => Number(aCenterList.id) === Number(aCenter.id));
                        if (center) {
                            centers += center.name + ', ';
                        }
                    });

                    if (centers === '') {
                        return;
                    }

                    setModalIndisponibilityMessage((prevMessage) => {
                        return (
                            <>
                                {prevMessage}
                                <div>Les centres : {centers.slice(0, -2)} sont indisponibles
                                    du {moment(aPeriod.metadata.startDate).format('DD/MM/YYYY à HH:mm')} au {moment(aPeriod.metadata.endDate).format('DD/MM/YYYY à HH:mm')}.
                                </div>
                                <br />
                                <div>Motif : {aPeriod.metadata.comment}</div>
                                <br />
                            </>
                        );
                    });
                });
            }
        })
        .catch((error) => {
            logError(alert, error);
        });
    };

    //#endregion

    //#region Functions
    const handleCloseModal = () => {
        resetComponent();
        setOpenModal(false);
    };
    const resetComponent = () => {
        setUnavailablePeriod({ centers: [], start: null, end: null, comment: null });
        setAvailablePeriod({
            id: 0,
            client: null,
            requestPass: null,
            centersList: [],
            centers: [],
            start: null,
            end: null,
            status: PLANIFICATION_STATUS.NEW,
            askType: 'wanted',
            convoyInfos: {
                contact: [{ name: '', phone: '' }],
                immatriculations: [{ immatriculation: '' }],
                confirmed: null,
            },
            concernedPath: { full: true, aller: [], retour: [], selectedPath: 'aller', fromReport: false },
            additionalInfos: { client: null, services: null },
            step: 1,
        });
        setPlanification(null);
        setIsInitialised(false);
        setIsDeleted(false);
    };
    const buildCentersList = (listCentersId, listCenters) => {
        return listCentersId.map((aCenterId) => {
            return {
                id: aCenterId,
                comment: null,
                status: null,
                confirmed: null,
                done: null,
            };
        });
    };
    const handleValidUnavailablePeriod = () => {
        if (!unavailablePeriod.start || !unavailablePeriod.end) {
            alert.error('Les dates de début et de fin sont requises et ne peuvent pas être vides');
            return false;
        }

        if (!moment(unavailablePeriod.start).isValid()) {
            alert.error('Le format de la date de début est invalide');
            return false;
        }

        if (!moment(unavailablePeriod.end).isValid()) {
            alert.error('Le format de la date de fin est invalide');
            return false;
        }

        if (unavailablePeriod.centers.length === 0) {
            alert.error(`Au moins un centre est requis pour créer une période d'indisponibilité`);
            return false;
        }

        setLoading(true);
        apiSavePeriod({
            id: planification?.id || 0,
            metadata: {
                startDate: moment(unavailablePeriod.start).format(),
                endDate: moment(unavailablePeriod.end).format(),
                statut: PLANIFICATION_STATUS.VALIDATED,
                centers: buildCentersList(unavailablePeriod.centers, centers),
                client: null,
                comment: unavailablePeriod.comment,
            },
            type: PLANIFICATION_STATUS.UNAVAILABLE,
            dossier_id: null,
            user_id: user.user_id,
        });
    };

    const deleteUnavailablePeriod = () => {
        setOpenDeleteDialog(true);
    };

    const onConfirmationDeleteModalClose = (value) => {
        if (value) {
            setLoading(true);
            apiSavePeriod({
                id: planification?.id || 0,
                metadata: {
                    startDate: moment(unavailablePeriod.start).format(),
                    endDate: moment(unavailablePeriod.end).format(),
                    statut: PLANIFICATION_STATUS.VALIDATED,
                    centers: buildCentersList(unavailablePeriod.centers, centers),
                    client: null,
                    comment: unavailablePeriod.comment,
                },
                type: PLANIFICATION_STATUS.UNAVAILABLE,
                dossier_id: null,
                user_id: user.user_id,
                deleted: true,
            });
        }
    };

    /**
     * @param step
     * @param permission
     * @param status
     * @returns {boolean} True si l'étape est désactivée, false sinon
     *
     * Step correspond à l'étape de la planification, chaque étape à une ou des permissions associées.
     * Permission correspond au niveau de permission requis permettant d'accéder au container. Permission prend le dessus sur step.
     * Status correspond au statut de la planification, chaque statut à une ou des permissions associées.
     */
    const handleDisabledStep = (step, permission, status) => {
        if (isDeleted) {
            return true;
        }

        // Si la planification est en statut "Nouveau" et que le profil est client, on peut modifier la planification
        // if (profil.profil === PROFIL.CLIENT && availablePeriod.status === PLANIFICATION_STATUS.NEW) {
        //     return false;
        // }

        // Si la planification est en statut "Accord émis" et que le profil est client ou intervenant, on ne peut pas modifier la planification
        if (profil.profil === PROFIL.INTERVENANT && availablePeriod.status === PLANIFICATION_STATUS.NEW) {
            return true;
        }

        // Si la planification est en statut "Accord émis" et que le profil est client ou intervenant, on ne peut pas modifier la planification
        if (availablePeriod.status === PLANIFICATION_STATUS.AGREEMENT_ISSUED && (profil.profil === PROFIL.CLIENT || profil.profil === PROFIL.INTERVENANT)) {
            return true;
        }

        if (status && permission) {
            if (permission.includes(profil.profil) && status.includes(availablePeriod.status)) {
                return false;
            } else {
                return step.some((s) => {
                    return !(s === availablePeriod.step && stepsPermissions[s].includes(profil.profil));
                });
            }
        }

        if (step && permission) {
            if (permission.includes(profil.profil)) {
                return false;
            } else {
                return step.some((s) => {
                    return !(s === availablePeriod.step && stepsPermissions[s].includes(profil.profil));
                });
            }
        }

        if (!step) {
            return !permission.includes(profil.profil);
        }

        if (Array.isArray(step)) {
            return !step.some((s) => {
                return (s === availablePeriod.step && stepsPermissions[s].includes(profil.profil));
            });
        }

        return !(step === availablePeriod.step && stepsPermissions[step].includes(2));
    };

    const handleStepErrors = () => {

        if (availablePeriod.id === 0 && ((availablePeriod.nbOptionalPlanification >= 2 && availablePeriod.askType === 'optional') || availablePeriod.nbWantedPlanification >= (planification?.dossier?.metadata.datePassage.nbPassageAller + planification?.dossier?.metadata.datePassage.nbPassageRetour))) {
            alert.error('Vous avez atteint le nombre maximum de planifications pour cette demande de passage');
            return false;
        }

        if (!moment(availablePeriod.start).isValid()) {
            alert.error('Le format de la date de début est invalide');
            return false;
        }

        if (!moment(availablePeriod.end).isValid()) {
            alert.error('Le format de la date de fin est invalide');
            return false;
        }

        if (availablePeriod.start && availablePeriod.end && moment(availablePeriod.start).isAfter(moment(availablePeriod.end))) {
            alert.error('La date de début ne peut pas être supérieure à la date de fin');
            return false;
        }

        if (availablePeriod.step === 1) {
            if (!availablePeriod.client) {
                alert.error('Le client est requis et ne peut pas être vide');
                return false;
            }
            if (!availablePeriod.requestPass) {
                alert.error('Le n° de dossier est requis et ne peut pas être vide');
                return false;
            }
            if (!availablePeriod.start || !availablePeriod.end) {
                alert.error('Les dates de début et de fin sont requises et ne peuvent pas être vides');
                return false;
            }
            if (!availablePeriod.askType) {
                alert.error('Le type de demande est requis et ne peut pas être vide');
                return false;
            }
            if (!availablePeriod.status) {
                alert.error('Le statut de la demande de planification est requise et ne peut pas être vide');
                return false;
            }
            // if (availablePeriod.convoyInfos.contact.filter((contact) => contact.name !== '' && contact.phone !== '').length === 0) {
            //   alert.error('Au moins un contact est requis et ne peut pas être vide');
            //   return false;
            // }
            // if (availablePeriod.convoyInfos.immatriculations.filter((immatriculation) => immatriculation.immatriculation !== '').length === 0) {
            //   alert.error('Au moins une immatriculation est requise et ne peut pas être vide');
            //   return false;
            // }
            if (listAvailableRequestPass.filter((availableRequestPass) => availableRequestPass === (requestPassId ? requestPassId : String(availablePeriod.requestPass))).length === 0) {
                alert.error('Un n° de dossier valide est requis');
                return false;
            }
        }

        if (availablePeriod.step === 0 || availablePeriod.step === 2 || availablePeriod.step === 5) {
            if (availablePeriod.centers.filter((aCenter) => aCenter.status === PLANIFICATION_STATUS.REFUSED && aCenter.comment === '').length > 0) {
                alert.error('Un commentaire est requis pour chaque centre ayant refusé');
                return false;
            }
        }

        return true;
    };

    const sendNotification = (recipientType, message, title = null) => {
        if (planification && planification.id) {
            axios({
                method: 'post',
                url: URL_API + '/planification/send-notif',
                data: {
                    recipientType: recipientType,
                    message: message,
                    title: title,
                    planificationId: planification.id,
                },
                params: { userAction: user.user_id, requestPassId: availablePeriod.requestPass },
            })
            .then(() => {
                setLoading(false);
            })
            .catch((error) => {
                logError(alert, error);
            });
        }
    };

    const handleStepAndNotify = () => {
        let numDemand = `[N°${availablePeriod.numDemand}/${availablePeriod.maxPlanification ?? '1'}]`;
        const formattedDate = dateFormatter(availablePeriod.start);

        const defaultTitle = `GATE : Demande de passage ${formattedDate} pour le dossier [N°${availablePeriod.requestPass}]`;

        if (oldStatus && availablePeriod.status === PLANIFICATION_STATUS.REFUSED && oldStatus !== PLANIFICATION_STATUS.REFUSED) {
            sendNotification(
                [PROFIL.CLIENT, PROFIL.INTERVENANT, PROFIL.GESTIONNAIRE],
                `La demande de passage ${formattedDate} pour le dossier [N°${availablePeriod.requestPass}] a été refusée par le gestionnaire.`,
                `GATE : Demande de passage refusée pour le dossier [N°${availablePeriod.requestPass}]`
            );
            return true;
        }

        if (oldStatus && availablePeriod.status === PLANIFICATION_STATUS.CANCELLED && oldStatus !== PLANIFICATION_STATUS.CANCELLED) {
            sendNotification(
                [PROFIL.CLIENT, PROFIL.INTERVENANT, PROFIL.GESTIONNAIRE],
                'La demande de passage ' + formattedDate + ' pour le dossier [N°' + availablePeriod.requestPass + '] a été annulée par le gestionnaire.',
                `GATE : Demande de passage annulée pour le dossier [N°${availablePeriod.requestPass}]`
            );
            return true;
        }

        // 1) Client => Nouvelle demande de passage => Statut nouveau
        // 	# Service TE vérif
        // 		: NOK => Statut Refusé => Notification au client => STOP
        // 		: OK  => Statut Accepté prévisionnel => Notification aux centres
        if (oldStatus && oldStatus === PLANIFICATION_STATUS.NEW) {
            if (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.INTERVENANT || profil.profil === PROFIL.GESTIONNAIRE) {
                if (availablePeriod.status === PLANIFICATION_STATUS.REFUSED) {
                    sendNotification(
                        [PROFIL.CLIENT, PROFIL.INTERVENANT, PROFIL.GESTIONNAIRE],
                        'La demande de passage ' + formattedDate + ' pour le dossier [N°' + availablePeriod.requestPass + '] a été refusée par le gestionnaire.',
                        defaultTitle
                    );
                    return true;
                } else if (availablePeriod.status === PLANIFICATION_STATUS.ACCEPTED_PROVISIONAL) {
                    sendNotification(
                        [PROFIL.INTERVENANT],
                        'La demande de passage ' + formattedDate + ' pour le dossier [N°' + availablePeriod.requestPass + '] mérite votre attention.',
                        defaultTitle
                    );
                    availablePeriod.step = 3;
                    return true;
                }
            }
        }

        //2) Centre => Statut prévisionnel
        // 	Si Non par un centre => Notification au service TE
        // 		# Service TE => Statut Refusé => Notification au client STOP
        // 	Si Non par differents centres => Notification aux centres STOP
        // 	Si Oui par TOUS les centres => Notification au service TE
        // 		# Service TE => Statut Accepté centre => Notification au client
        if (availablePeriod.status === PLANIFICATION_STATUS.ACCEPTED_PROVISIONAL) {
            if (availablePeriod.centers.filter((aCenter) => aCenter.status === PLANIFICATION_STATUS.REFUSED).length > 0) {
                // let centers = availablePeriod.centers.filter((aCenter) => aCenter.status === PLANIFICATION_STATUS.REFUSED);
                sendNotification([PROFIL.INTERVENANT, PROFIL.GESTIONNAIRE], 'La demande de passage ' + formattedDate + ' pour le dossier [N°' + availablePeriod.requestPass + '] est refusée par un centre', defaultTitle);
                // sendNotification(PROFIL.CLIENT, 'Votre demande de planification a été refusée.');
                return true;
                // } else if (availablePeriod.centers.filter((aCenter) => aCenter.status === PLANIFICATION_STATUS.VALIDATED).length !== availablePeriod.centers.length) {
                //     sendNotification(PROFIL.INTERVENANT, 'Plusieurs centres n\'ont pas encore validé la demande de passage.');
                //     return true;
            } else {
                sendNotification([PROFIL.GESTIONNAIRE], 'Tous les centres ont validé la demande de passage [N°' + availablePeriod.requestPass + '].', defaultTitle);
                availablePeriod.step = 4;
                return true;
            }
        }

        if (availablePeriod.status === PLANIFICATION_STATUS.ACCEPTED_CENTER && oldStatus !== PLANIFICATION_STATUS.ACCEPTED_CENTER && (profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.ADMINISTRATEUR)) {
            sendNotification([PROFIL.CLIENT, PROFIL.INTERVENANT], 'La demande de passage ' + formattedDate + ' pour le dossier [N°' + availablePeriod.requestPass + '] est acceptée.', defaultTitle);
            availablePeriod.step = 5;
            return true;
        }

        //3) Client => Confirmation du passage
        // 	Si Non => Notification au service TE
        // 		# Service TE => Statut Annulé => Notification aux centres STOP
        // 	Si Oui => Notification au service TE
        // 		# Service TE => Statut Confirmé client => Notification aux centres
        // if (availablePeriod.status === PLANIFICATION_STATUS.ACCEPTED_CENTER && oldStatus !== availablePeriod.status && (profil.profil === PROFIL.CLIENT || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.ADMINISTRATEUR)) {
        //     // if (!availablePeriod.convoyInfos.confirmed) {
        //     //     // sendNotification(PROFIL.GESTIONNAIRE, 'Le client a annulé son passage.');
        //     //     // sendNotification(PROFIL.INTERVENANT, 'La demande de passage a été annulée par le client.');
        //     //     // return true;
        //     // } else {
        //         sendNotification([PROFIL.INTERVENANT], 'La demande de passage ' + numDemand + ' pour le dossier [N°' + availablePeriod.requestPass + '] est confirmée par le client.');
        //         availablePeriod.step = 5;
        //         return true;
        //     // }
        // }

        if (availablePeriod.status === PLANIFICATION_STATUS.CONFIRMED_CLIENT && oldStatus !== availablePeriod.status && (profil.profil === PROFIL.CLIENT || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.ADMINISTRATEUR)) {
            sendNotification([PROFIL.INTERVENANT], 'La demande de passage ' + numDemand + ' pour le dossier [N°' + availablePeriod.requestPass + '] est confirmée par le client.', defaultTitle);
        }

        //4) Centre => Confirmation du passage
        // 	Si Non par un centre => Notification au service TE
        // 		# Service TE => Statut Annulé => Notification au client STOP
        // 	Si Non par différents centres => Notification aux centres STOP
        // 	Si Oui par TOUS les centres => Notification au service TE
        // 		# Service TE => Statut Confirmé centres => Notification au client
        // 				+ Génération de l'accord de passage => Statut Accord émis => Notification Client & Centre
        if (availablePeriod.status === PLANIFICATION_STATUS.CONFIRMED_CLIENT) {
            if (availablePeriod.centers.filter((aCenter) => aCenter.confirmed === false || aCenter.confirmed === 'false').length > 0) {
                sendNotification([PROFIL.INTERVENANT], 'La demande de passage ' + numDemand + ' pour le dossier [N°' + availablePeriod.requestPass + '] n\'est pas validée par un centre.');
                return true;
            } else if (availablePeriod.centers.filter((aCenter) => aCenter.confirmed === null || aCenter.confirmed === '').length > 0) {
                // sendNotification(PROFIL.INTERVENANT, 'Plusieurs centres n\'ont pas encore confirmé la demande de passage.');
                // return true;
            }
            // else {
            //     sendNotification([PROFIL.CLIENT, PROFIL.INTERVENANT], 'La demande de passage ' + numDemand + ' pour le dossier [N°' + availablePeriod.requestPass + '] est confirmée par les centres.');
            //     availablePeriod.step = 6;
            //     return true;
            // }
        }

        if (availablePeriod.status === PLANIFICATION_STATUS.CONFIRMED_CENTERS && oldStatus !== availablePeriod.status && (profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.ADMINISTRATEUR)) {
            sendNotification([PROFIL.CLIENT, PROFIL.INTERVENANT], 'La demande de passage ' + numDemand + ' pour le dossier [N°' + availablePeriod.requestPass + '] est confirmée par les centres.');
            availablePeriod.step = 7;
            return true;
        }
    };

    const handleTronconChange = (e, index, type) => {
        let updatedAvailablePeriod = { ...availablePeriod };

        updatedAvailablePeriod.concernedPath[type === 'aller' ? 'retour' : 'aller'] = []

        if (updatedAvailablePeriod.concernedPath.full == true)
            updatedAvailablePeriod.concernedPath[type] = updatedAvailablePeriod[type]
        else {
            if (e !== null)
                updatedAvailablePeriod.concernedPath[type].push(availablePeriod[type][index]);
            else
                updatedAvailablePeriod.concernedPath[type] = [];
        }

        setAvailablePeriod(updatedAvailablePeriod);
    };

    const removeTroncon = (numeroSection, type) => {
        let updatedPaths = { ...availablePeriod.concernedPath };

        if (!availablePeriod.concernedPath.full) {
            if (updatedPaths[type] && updatedPaths[type].length !== 0) {
                let index = updatedPaths[type].findIndex((aTroncon) => aTroncon.numeroSection === numeroSection);
                if (index !== -1) {
                    updatedPaths[type].splice(index, 1);
                }
            }
        } else {
            if (type === 'aller') {
                updatedPaths.aller = availablePeriod.aller.filter((aTroncon) => aTroncon.numeroSection !== numeroSection);
            } else {
                updatedPaths.retour = availablePeriod.retour.filter((aTroncon) => aTroncon.numeroSection !== numeroSection);
            }

            updatedPaths.full = false;
        }

        setAvailablePeriod({
            ...availablePeriod,
            concernedPath: updatedPaths,
        });
    };


    const handleValidAvailablePeriod = () => {
        // if (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) {
        //   availablePeriod.step = statusToStep(availablePeriod.status);
        // }

        if (!handleStepErrors()) {
            return false;
        }

        handleStepAndNotify();

        // Pour full=false, ne sauvegarder que les centres des tronçons concernés
        const centersToSave = (() => {
            if (String(availablePeriod.concernedPath?.full) === "true") return availablePeriod.centers;
            const dir = availablePeriod.concernedPath?.selectedPath;
            const troncons = availablePeriod.concernedPath?.[dir] ?? [];
            const tronconCentreIds = new Set(troncons.flatMap(t => (t.centres || []).map(id => Number(id))));
            return tronconCentreIds.size > 0
                ? availablePeriod.centers.filter(c => tronconCentreIds.has(Number(c.id)))
                : availablePeriod.centers;
        })();

        setLoading(true);
        apiSavePeriod({
            id: planification?.id || 0,
            metadata: {
                additionalInfos: availablePeriod.additionalInfos,
                askType: availablePeriod.askType,
                centers: centersToSave,
                client: availablePeriod.client,
                concernedPath: availablePeriod.concernedPath,
                convoyInfos: availablePeriod.convoyInfos,
                endDate: moment(availablePeriod.end).format(),
                startDate: moment(availablePeriod.start).format(),
                status: availablePeriod.status,
                step: availablePeriod.step,
            },
            type: PLANIFICATION_STATUS.AVAILABLE,
            dossier_id: availablePeriod.requestPass,
            user_id: user.user_id,
        });
    };

    const updateMaxPlanifications = () => {
        let nbOptionalPlanification = 0;
        let nbWantedPlanification = 0;
        let nbPlanification = 0;
        let maxPlanification = 0;
        let currentPlanifIndex = 0;
        let remainingAller = 0;
        let remainingRetour = 0;

        if (concernedRequestPass) {
            const weight = (p) => p.metadata.concernedPath.full == true ? 1 : 0.5;
            const isActive = (p) => p.deleted === false && p.metadata.status !== PLANIFICATION_STATUS.REFUSED;

            const wantedActive = concernedRequestPass.planifications.filter((p) => p.metadata.askType === 'wanted' && isActive(p));
            nbWantedPlanification = wantedActive.reduce((sum, p) => sum + weight(p), 0);
            nbPlanification = concernedRequestPass.planifications
                ? concernedRequestPass.planifications.filter((p) => isActive(p)).length
                : 0;
            let nbPassageAller = concernedRequestPass.metadata.datePassage.nbPassageAller;
            let nbPassageRetour = concernedRequestPass.metadata.datePassage.nbPassageRetour;
            remainingAller = nbPassageAller - wantedActive
                .filter((p) => p.metadata.concernedPath.selectedPath === 'aller')
                .reduce((sum, p) => sum + weight(p), 0);
            remainingRetour = nbPassageRetour - wantedActive
                .filter((p) => p.metadata.concernedPath.selectedPath === 'retour')
                .reduce((sum, p) => sum + weight(p), 0);
            maxPlanification = nbPassageAller + nbPassageRetour;

            if (planification) {
                const sorted = concernedRequestPass.planifications
                    .filter((p) => p.deleted === false)
                    .sort((a, b) => a.id - b.id);
                let n = 0;
                for (const p of sorted) {
                    n += weight(p);
                    if (p.id === planification.id) break;
                }
                currentPlanifIndex = n;
            }
            nbOptionalPlanification = concernedRequestPass.planifications
                .filter((p) => p.metadata.askType === 'optional' && isActive(p))
                .reduce((sum, p) => sum + weight(p), 0);
        }

        setAvailablePeriod({
            ...availablePeriod,
            nbOptionalPlanification: nbOptionalPlanification,
            nbWantedPlanification: nbWantedPlanification,
            nbPlanification: nbPlanification,
            maxPlanification: maxPlanification,
            numDemand: currentPlanifIndex,
            remainingAller: remainingAller,
            remainingRetour: remainingRetour,
            initialPath: planification ? planification.metadata.concernedPath.selectedPath : null,
        });
    };
    //#endregion

    return (
        <>
            <>
                {mode === PLANIFICATION_STATUS.UNAVAILABLE &&
                    <UnavailablePeriodModal
                        openModal={openModal}
                        css={css}
                        demandePassageStyle={demandePassageStyle}
                        loading={loading}
                        listCenters={listCenters}
                        unavailablePeriod={unavailablePeriod}
                        setUnavailablePeriod={setUnavailablePeriod}
                        handleValidUnavailablePeriod={handleValidUnavailablePeriod}
                        deleteUnavailablePeriod={deleteUnavailablePeriod}
                        handleCloseModal={handleCloseModal}
                        profil={profil}
                    />
                }

                {mode === PLANIFICATION_STATUS.AVAILABLE &&
                    <AvailablePeriodModal
                        css={css}
                        demandePassageStyle={demandePassageStyle}
                        loading={loading}
                        availablePeriod={availablePeriod}
                        profil={profil}
                        openModal={openModal}
                        planification={planification}
                        resetComponent={resetComponent}
                        handleDisabledStep={handleDisabledStep}
                        handleTronconChange={handleTronconChange}
                        removeTroncon={removeTroncon}
                        handleValidAvailablePeriod={handleValidAvailablePeriod}
                        handleCloseModal={handleCloseModal}
                        statusList={statusList}
                        listAvailableRequestPass={listAvailableRequestPass}
                        listeRaisonsSociales={listeRaisonsSociales}
                        centerStatusList={centerStatusList}
                        goToDate={goToDate}
                        setAvailablePeriod={setAvailablePeriod}
                        setOpenContractModal={setOpenContractModal}
                        createdFromRequestPass={createdFromRequestPass}
                        setOpenModalIndisponibility={setOpenModalIndisponibility}
                        isDeleted={isDeleted}
                    />
                }
            </>

            {(profil.profil === 1 || profil.profil === 2) &&
                <>
                    <MyDialog
                        open={openDeleteDialog}
                        handleClose={setOpenDeleteDialog}
                        title={`Voulez-vous vraiment supprimer cette période d'indisponibilité ?`}
                        content={'Cette action est irréversible'}
                        dialog={onConfirmationDeleteModalClose}
                    />
                </>
            }

            {openModalIndisponibility &&
                <MyDialog
                    open={openModalIndisponibility}
                    handleClose={setOpenModalIndisponibility}
                    hideCloseBtn={true}
                    trueButtonLabel={'Fermer'}
                    title={`Indisponibilités`}
                    content={modalIndisponibilityMessage}
                />
            }

            <>
                {planification && planification.dossier &&
                    <ModalViewContract openModal={openContractModal} setOpenModal={setOpenContractModal}
                                       color={'#0094ca'} planification={planification} contractId={contractId}
                                       user={user} profil={profil} dossier={planification.dossier} />}
            </>
        </>
    );
};

export default EditPlanificationModal;
